import { render, staticRenderFns } from "./plan.vue?vue&type=template&id=5cb15d02&scoped=true"
import script from "./plan.vue?vue&type=script&lang=js"
export * from "./plan.vue?vue&type=script&lang=js"
import style0 from "./plan.vue?vue&type=style&index=0&id=5cb15d02&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb15d02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cb15d02')) {
      api.createRecord('5cb15d02', component.options)
    } else {
      api.reload('5cb15d02', component.options)
    }
    module.hot.accept("./plan.vue?vue&type=template&id=5cb15d02&scoped=true", function () {
      api.rerender('5cb15d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/basicconfig/plan.vue"
export default component.exports